var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[_vm.customClass, _vm.buttonClasses[_vm.styleType]]},[_vm._t("default",[_vm._v("Click")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }